import api from "../store/services/api";

const getLabels = async (params) => {
  return await api.get("/labels/labels/", { params });
};

const getLabelById = async (labelId) => {
  return await api.get(`/labels/labels/${labelId}/`);
};

const createLabel = async (labelData) => {
  return await api.post("/labels/labels/", labelData, {
    headers: { "Content-Type": "application/json" },
  });
};

const updateLabel = async (labelId, labelData) => {
  return await api.put(`/labels/labels/${labelId}/`, labelData, {
    headers: { "Content-Type": "application/json" },
  });
};

const deleteLabel = async (labelId) => {
  return await api.delete(`/labels/labels/${labelId}/`);
};

const cancelLabel = async (labelId, reason) => {
  return await api.post(
    `/labels/labels/${labelId}/cancel/`,
    { reason },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

const regenerateLabel = async (labelId, regenerateData) => {
  return await api.post(
    `/labels/labels/${labelId}/regenerate/`,
    {
      batch_number: regenerateData.batchNumber,
      manufacture_date: regenerateData.manufactureDate,
      expiration_date: regenerateData.expirationDate,
    },
    {
      headers: { "Content-Type": "application/json" },
    }
  );
};

const getExpirationStatus = async (labelId) => {
  return await api.get(`/labels/labels/${labelId}/expiration_status/`);
};

const getBatchHistory = async (labelId) => {
  return await api.get(`/labels/labels/${labelId}/batch_history/`);
};

const getExpiredLabels = async (params) => {
  return await api.get("/labels/labels/expired/", { params });
};

const getExpiringSoonLabels = async (params) => {
  return await api.get("/labels/labels/expiring_soon/", { params });
};

const LabelsService = {
  getLabels,
  getLabelById,
  createLabel,
  updateLabel,
  deleteLabel,
  cancelLabel,
  regenerateLabel,
  getExpirationStatus,
  getBatchHistory,
  getExpiredLabels,
  getExpiringSoonLabels,
};

export default LabelsService;
